import sanitizeHtml from 'sanitize-html';

/**
 * import sanitizeHtml from 'sanitize-html'; !!!!
 * must be imported in the main entry point of every module where it is used
 * to avoid issues with bundlers like webpack.
 */
export function sanitizeHtmlInput(value: string) {
	if (typeof value !== 'string' || !value) {
		return value;
	}

    return sanitizeHtml(value, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img']),
        allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            img: ['src', 'alt', 'title', 'width', 'height'],
            '*': ['class', 'style', 'id', 'data-*'],
        },
        allowedSchemesByTag: {
            img: ['data', 'http', 'https'],
        },
    });
}

/**
 * import sanitizeHtml from 'sanitize-html'; !!!!
 * must be imported in the main entry point of every module where it is used
 * to avoid issues with bundlers like webpack.
 */
export function sanitizeHtmlFields(object: Record<string, any>, fields: string[]) {
	for (const key of fields) {
		if (object[key]) {
			object[key] = sanitizeHtmlInput(object[key]);
		}
	}

}
